import ManagePages from "./mainPage";

export default ManagePages